export const load = () => ({
	title: 'IndowPRO Commercial Glazing Specs',
	h1: 'IndowPRO Performance for Acoustic Consultants & Engineers',
	description:
		'Engineer predictable noise mitigation with IndowPRO. Download full acoustic test reports, CSI 3-Part Specs, and Transmission Loss data.',
	showTitle: true,
});
